module.exports = __webpack_public_path__ + "img/info.c245625c.png";